import Index from '@/pages/keycloak/Index'
import List from '@/pages/keycloak/List'
import Create from '@/pages/keycloak/Create'
import Modify from '@/pages/keycloak/Modify'

export default {
  path: 'keycloak',
  component: Index,  
  children: [
    {
      path: 'index',
      component: List
    },
    {
      path: 'create',
      component: Create
    },
    {
      path: 'modify/:id',
      component: Modify
    },
  ]
}

